// Message d'erreur d'une réponse du serveur, affichable tel quel.
//
// Une erreur de validation (422) renvoie ``detail`` sous forme de LISTE
// d'objets : l'afficher directement faisait planter React (page blanche,
// don impossible). On ne garde ``detail`` que s'il s'agit d'un texte.
export function messageErreur(erreur, defaut) {
  const detail = erreur?.response?.data?.detail;
  return typeof detail === "string" && detail.trim() ? detail : defaut;
}
